
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/commercial_notice",
      function () {
        return require("private-next-pages/commercial_notice/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/commercial_notice"])
      });
    }
  